module.exports = __webpack_public_path__ + "media/18.239bb58d.mp3";